<template>
  <el-form :inline="true" @submit.native.prevent>
    <div class="form-fields">
      <el-form-item
        v-for="field in formFields"
        :key="field.key"
        :label="getFieldLabel(field)"
      >
        <component :is="renderField(field)" />
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import BaseComponent from "./BaseComponent";

export default {
  name: "FormComponent",
  mixins: [BaseComponent],
  props: {
    formFields: {
      type: Array,
      required: true,
      validator: (value) => {
        const validFields = value.filter(
          (field) => field && field.config && field.config.type
        );
        if (validFields.length < value.length) {
          console.warn(
            "发现无效字段:",
            value.filter((field) => !field || !field.config)
          );
        }
        return true;
      },
    },
    params: {
      type: Object,
      required: true,
    },
    parentCtx: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formData: { ...this.params },
    };
  },
  watch: {
    params: {
      handler(newVal) {
        this.formData = { ...newVal };
      },
      deep: true,
    },
  },
  methods: {
    // 渲染字段
    renderField(item) {
      const field = item.config || item;

      if (!field || typeof field !== "object") {
        console.warn("无效的字段对象:", field);
        return this.renderDefaultField();
      }

      if (!field.type || typeof field.type !== "string") {
        console.warn("字段缺少 type 属性:", field);
        return this.renderDefaultField();
      }

      const renderName = `render${
        field.type.charAt(0).toUpperCase() + field.type.slice(1)
      }`;
      const renderFunc = this[renderName];

      if (!renderFunc || typeof renderFunc !== "function") {
        console.warn(`未实现的字段类型: ${field.type}`, field);
        return this.renderDefaultField();
      }

      return renderFunc(field);
    },
    // 渲染默认字段
    renderDefaultField() {
      return {
        render: (h) =>
          h("div", { staticClass: "default-field" }, "未定义的字段类型"),
      };
    },
    // 输入框渲染
    renderInput(field) {
      const self = this;
      return {
        render: (h) =>
          h("el-input", {
            key: field.key,
            props: {
              value: self.formData[field.modelKey],
            },
            attrs: {
              placeholder: field.placeholder,
              clearable: field.clearable,
            },
            on: self.bindEvents(field, null) || {},
            nativeOn: self.bindNativeEvents(field, null) || {},
          }),
      };
    },
    // 选择器渲染
    renderSelect(field) {
      const self = this;
      const options = field.options;
      const defaultOptions = self.$common.CommonStatusList;
      const finalOptions = Array.isArray(options)
        ? options
        : Array.isArray(defaultOptions)
        ? defaultOptions
        : [];

      return {
        render: (h) =>
          h(
            "el-select",
            {
              props: {
                value: self.formData[field.modelKey],
              },
              attrs: {
                placeholder: field.placeholder || "请选择",
                clearable: field.clearable,
              },
              on: self.bindEvents(field, null) || {},
            },
            finalOptions.map((item) =>
              h("el-option", {
                props: {
                  label: item.name,
                  value: item.id,
                },
              })
            )
          ),
      };
    },
    // 按钮组渲染
    renderActions(field) {
      const self = this;
      return {
        render: (h) =>
          h(
            "div",
            {
              staticClass: "action-buttons",
              style: { display: "flex", gap: "8px" },
            },
            field.buttons.map((btn) =>
              h(
                "el-button",
                {
                  attrs: {
                    type: btn.type,
                    round: btn.round,
                    size: btn.size,
                  },
                  on: self.bindEvents(btn, null) || {},
                },
                btn.text
              )
            )
          ),
      };
    },
    // 日期范围渲染
    renderDateRange(field) {
      const self = this;
      const [startKey, endKey] = field.modelKeys;
      return {
        render: (h) =>
          h(
            "div",
            {
              staticClass: "date-range",
            },
            [
              h("el-date-picker", {
                props: {
                  value: self.formData[startKey],
                },
                attrs: {
                  placeholder: field.pickers.start.placeholder,
                  valueFormat: field.props.valueFormat || "timestamp",
                  pickerOptions: self.parentCtx.startPickerOptions,
                },
                on: self.bindEvents(
                  field.pickers.start,
                  null,
                  field.modelKeys[0]
                ),
              }),
              h("span", { style: { margin: "0 10px" } }, "-"),
              h("el-date-picker", {
                props: {
                  value: self.formData[endKey],
                },
                attrs: {
                  placeholder: field.pickers.end.placeholder,
                  valueFormat: field.props.valueFormat || "timestamp",
                  pickerOptions: self.parentCtx.endPickerOptions,
                  disabled: !self.formData[startKey],
                },
                on: self.bindEvents(
                  field.pickers.end,
                  null,
                  field.modelKeys[1]
                ),
              }),
            ]
          ),
      };
    },
  },
};
</script>
<style scoped>
.form-fields {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.form-fields >>> button {
  margin: 0;
}
</style>

